export default {
  language: '請選擇語言',
  terms: '條款 · 隱私權政策',
  Disclaimers: '免責聲明與風險提示',
  annualized: '平均年化56.74%，累計收益163.15%。',
  drawdown: ' 平均年化87.43%，累計收益145.72%',
  college:'衍泰學院',
  web3:'衍泰WEB3',
  home: {
    attention: '注意：為保障資產安全，聊天場景中嚴禁透露錢包地址、私鑰等敏感資訊',
    EmailInput: '請輸入您的信箱',
    TechnicalSupport: '技術支援',
    emailFormat: '請輸入正確的信箱格式',
    contact: '聯絡我們',
    title: '矩陣力量',
    banner_desc: '讓每一位投資者都可以享受到頂尖AI量化策略帶來的前景',
    banner_highlight: '量化交易+AI智能',
    banner_future: '驅動行業交易未來',
    discover: '發現更多 →',
    about: '常見問題',
    explore: '開始探索',
    schematicDiagram:'近兩年示意圖',
    dataModule: {
      funds: "資金由",
      exchange: '頂級服務商託管 ',
      description: '完全符合美國監管規定，客戶資產完全隔離。 通過MPC和HSM實現多層保護，並獲得SOC 2 Type II認證',
      scale: '衍泰平台策略服務資金規模已達到',
      StrategicPlan: '策略方案',
      yieldRate: '預估年化收益率',
      strategy: '隨時隨地，從您的交易策略中獲得回報',
      // return:'',
      advantage: '強大的量化策略結合MatrixPower的安全與保障，帶來極致的體驗。'
    },
    carousel: {
      hedge: '跨所對沖',
      arbitrage: '套利策略',
      MarketPremise: '策略覈心',
      MarketPremise_1: '同一標定物在不同交易所出現價差時通過不同手段穩定套利。',
      build: '策略亮點',
      build_1: '無懼市場漲跌，穩定獲利。',
      mean: '價格均值回歸',
      mean_1: '依賴均值回歸邏輯，盈利來源為跨交易所價差',
      view: '查看更多 ',
      foreignExchange: '高頻量化投資',
      arbitrage_1: '策略',
      collect: '策略覈心',
      collect_1: '採集近10年全球主要外匯市場交易數據，通過AI統計大模型精准抓取超過30個影響外匯漲跌的顯性因數，通過這些因數進行高頻交易，獲取超高額收益。',
      factor: '策略亮點',
      factor_1: '進行超高頻交易，年回報率超過100%',
      combination: '因子組合策略優化',
      combination_1: '當高準確率因子組合發出明確信號時，自動交易'
    },
    card: {
      company_intro: '查看更多',
      discover: '發現更多',
      company_intro_one: '衍泰金融科技有限公司',
      ai_quant: 'AI量化',
      ai_quant_one: 'AI量化是以高效的交易程序代替傳統交易員的交...',
      app_download: 'APP下載',
      app_download_one: 'Matrix Power是一款通過ai量化技術幫助您實現...',
      app_matrix_desc: '矩陣力量APP是一款通過ai量化技術幫助您實現數字資產增值的服務管家。',
      contact_us: '聯繫我們',
      contact_us_one: '衍泰金融科技有限公司'
    },
    accordion: {
      title1: '公司介紹',
      content1: 'MP-穩贏項目是在提供專業的AI量化技術策略，團隊成員均具備資深、專業的金融工程、IT、統計學背景。我們的目標是打破傳統金融市場量化交易的高門檻，為有需要的投資者，以公平的方式分配利潤，以透明的原則公開交易數據以及客戶資產數據。',
      title2: '衍泰的使命',
      content2: '通過我們成熟的量化策略以及交易算法，幫助投資者在特定市場中進行7*24小時無間斷的交易。同時，我們為了達到金融的普惠性質，亦為小客戶提供託管資質。',
      title3: '衍泰的優勢',
      content3: '穩定高收益，無市場風險。高收益的來源為MP-AI量化交易的優秀算法以及數字貨幣的高收益性，穩定年化可達60%，周度回報數據自團隊2023年創辦開始回撤基本為0，即沒有虧損數據。並且我們的資產是託管在瑞士銀行的獨立賬戶內，如發生非市場風險，我們的託管資產由瑞士銀行的信託保險全額賠付。',
      title4: '為什麼選擇衍泰',
      content4: '同業可分為傳統基金機構與傳統量化機構。相較於傳統金融機構，我們的收益率是他們無法匹敵的，並且傳統金融機構以擴大管理規模為目標，收取管理費，並不在乎投資者的收益情況。相較於傳統的量化機構，他們的起投門檻至少為300~800萬美元，普通投資者根本無法參與。需要特定私行或渠道才有機會參與傳統的量化交易，並且收益率遠不如我們的量化策略。',
      title5: '如何獲利',
      content5: '我們的盈利模式為，我們的AI量化策略在設定好參數後，自動對Binance、Bybit、okx、Bitget交易所的前100市值的數字貨幣進行監測。如發現價差，我們高賣低買進行套利，最高每秒可進行30多次交易，完全由AI量化系統自動進行。因為是完全對沖，交易不受價格漲跌影響，買漲買跌都賺錢。'
    },
    partner: {
      title: '衍泰合作企業',
      subtitle: 'AI量化策略將在知名交易所公開透明運作，交易全流程公開透明',
      slogan: '科技驅動，創新引領'
    },
    quant: {
      title: '衍泰量化',
      subtitle: '致力於以頂尖的AI技術，賦能量化交易模型，實現超額收益',
      leftTitle: '三大投資策略年化收益',
      leftDesc: '數字資產、外匯、A股期權三大量化策略模型獨立運營，風險隔離，適配多種風險偏好',
      stat1: '外匯多因子交易模型',
      stat2: '跨所無風險套利模型',
      stat3: 'A股ETF期權套利',
      viewDetail: '查看詳情',
      feeLabel: '技術服務費',
      securityTitle: '安全矩陣',
      sec1: '資金劃轉權限',
      sec1Val: '0',
      sec2: '雙重風控攔截',
      sec2Val: '100%',
      sec3: '產品磨合期',
      sec3Val: '0天',
      sec4: '極致流動性',
      sec4Val: '7x24h'
    },
    service: {
      title: '服務規模',
      subtitle: '通過AI量化策略，持續為投資者帶來穩定的資本增值，所有數據由第三方平台提供',
      item1: '高淨值客戶',
      num2: '7400萬+',
      item2: '美元管理規模',
      num3: '3年+',
      item3: '業務無回撤'
    },
    aiSection: {
      title: '衍泰AI',
      subtitle: '衍泰AI驅動自主數字經濟，AI創造價值、人類分享回報。',
      running: 'AI運行中',
      participants: '活躍人類參與者',
      targetApr: '目標年化',
      aiAgents: 'AI代理',
      aiGenerated: 'AI生成',
      engine: 'AI推廣引擎',
      l1: '最新AI模型',
      l1v: '準確率',
      l2: '7×24小時全天候在線',
      l2v: '全天候在線',
      l3: '智能高效完成任務',
      l3v: '效率提高',
      l4: '企業級安全保障',
      l4v: '可靠率',
      productsTitle: '兩大AI衍生產品',
      productsDesc: '衍泰AI開發較成熟，具備實際應用能力，用戶可以通過使用目前的兩大AI衍生品（AiGenNext、AI推廣引擎）產生收益'
    },
    faqSubtitle: '解答您的疑慮，助您快速上手',
    fixed: {
      title: 'APP固收產品',
      subtitle: '旨在降低小資金的投資門檻，做到無風險、無封閉期的普惠金融',
      download: '前往下載',
      feat1: '起投金額：$1000',
      feat2: '平均年化：15%',
      feat3: '無封閉期'
    },
    notOpen: '暫未開放'
  },
  about: {
    titleName: '衍泰金融科技',
    titleName1: '關於我們',
    gs: '有限公司',
    qurMission: '我們的使命',
    company_profile: '衍泰金融科技有限公司（Matrix Power）是一家香港注册，在中國內地擁有獨立數位版權的量化科技公司。 覈心研發團隊均來自於國際頂尖大廠與投資銀行。',
    team_intro: '我們的使命是致力於以頂尖的AI量化策略，打破傳統金融市場的門檻，使得無論機構與個人投資者都可以最低成本的享受到AI量化策略帶來的穩定增值。',
    slogan: '匯聚才智、打破壁量、共享未來',
    commitment: '是我們對每位投資者的承諾!',
    work: '除此之外，我們的所有工作都是',
    user: '以用戶為中心,',
    safety: '用戶保護為我們的第一要務。所以我們在Matrix Power系統中嵌入了最先進的安全措施和嚴格的數據隱私控制措施。',
    name: '衍泰金融科技有限公司',
    reason: '為何要選擇',
    SimplifiedName: '衍泰量化',
    aiName: '衍泰AI',
    title1: 'AI量化業務',
    Department: {
      DepartmentName1: '科技運營部',
      DepartmentIntroduction1: '負責MatrixPower APP功能開發運營',
      DepartmentName2: '區塊鏈科技技術研發部',
      DepartmentIntroduction2: '專注於RWA區塊鏈技術開發',
      DepartmentName3: '量化投資研究部',
      DepartmentIntroduction3: 'AI量化策略開發',
      DepartmentName4: '國際事業部',
      DepartmentIntroduction4: '新加坡、越南、北非市場'
    },
    title2: '數字資產',
    prospect: {
      prospectName1: '多策略AI引擎',
      prospectHome1: '我們不依賴市場單一方向的漲跌。 通過統計套利、市場中性、事件驅動、宏觀對沖等多元化的量化模型，我們在全球所有大類資產市場中，系統性挖掘被錯誤定價的機會，剝離市場系統性風險，純粹獲取超額收益。',
      prospectName2: '尖端科技驅動',
      prospectHome2: '我們的策略根植於海量市場數據，依託自有超高算力與頂級的AI算灋。 通過高頻的資料處理與模式識別，我們的系統能比傳統管道更早、更精准地預見市場微小的非均衡性。',
      prospectName3: '嚴格的風險控制',
      prospectHome3: '風險控制是我們的第一信條。我們採用實時價值監控、多維度壓力測試以及嚴格的止損與倉位管理機制，確保投資組合在面對極端行情時依然保持強韌性，將下行風險牢牢鎖在籠中。'
    }
  },
  quantify: {
    strategy: '我們的策略',
    arbitrage: '跨所對沖',
    StrategicCore: '由於加密貨幣市場是去中心化且分散的，不同交易所之間可能因為流動性、使用者需求、交易量或區域差異等原因，導致同一幣種的價格出現偏差。該策略的核心在於：',
    StrategicCore_1: '在價格較低的交易所買入某種數位貨幣。',
    StrategicCore_2: '同時在價格較高的交易所賣出同等數量的該數位貨幣',
    StrategicCore_3: '從這兩個交易的價差中賺取利潤。',
    StrategicCore_4: '這種策略為超低風險套利形式，因為它不依賴於預測市場未來的整體走向，而是利用瞬時存在的市場低效性。',
    strategyName: "高頻量化",
    collect: '數據採集',
    dataCollection: '顯性因子的提取與篩選',
    content: "採集近10年全球主要外匯市場交易數據，涵蓋不同經濟週期（繁榮期、衰退期、復甦期），確保樣本的完整性與代表性",
    screeningMethod: "採用貝葉斯資訊準則（BIC）進行因子篩選，剔除相關性弱、解釋力不足的變數。透過動態線性迴歸擬合，量化各因子對匯率變動的影響權重，最終提取出 ABCDEFG 等多個核心顯性因子。經樣本內回溯測試，入選因子的單獨預測準確率均達到 90% 以上，確保因子的有效性與穩定性。",
    triggerCondition: "當高準確率因子組合發出明確信號時，判斷外匯上漲機率為99.95%，此時向交易所自動發出交易指令。 ",
    strategyCore: "核心：基於多因子模型的精準決策體系",
    change: '了解我們如何為他人帶來改變',
    experience: '聽聽我們的客戶分享與Matrix Power合作的經歷，以及我們的投資策略如何協助他們達成財務目標',
    defaultPanels: {
      title1: "Matrix Power彻底改變了我管理數位資產的方式。他們的AI量化策略協助我的投資組合在過去一年成長了45%，遠超我的預期。",
      name1: "張明",
      label1: "科技創業者",
      belonging1: '未來科技有限公司',
      title2: "做為一名剛開始接觸數位資產的投資者，Matrix Power的團隊給了我很多寶貴的指導。他們的平台易於使用，策略簡單明瞭，讓我能夠安心投資。",
      name2: "陳雅琳",
      label2: "數位資產愛好者",
      belonging2: '個人投資者',
      title3: "做為一名經驗豐富的投資人，我對Matrix Power的專業水準印象深刻。他們的市場分析精準，風險管理策略完善，是值得信賴的合作夥伴。",
      name3: "李婷",
      label3: "資深投資人",
      belonging3: '全球投資集團',
      title4: "我向所有客戶推薦Matrix Power。他們的服務透明度高，客戶支援團隊回應迅速，最重要的是，他們能夠持續創造穩定的投資報酬。",
      name4: "王建國",
      label4: "財務顧問",
      belonging4: '財富管理顧問公司'
    },
    attention: '聯繫我們',
    title: '什麼是AI量化？',
    introduction: 'AI量化是以高效的交易程式代替傳統交易員的交易職責。 量化交易的本質是通過大數據及特定的統計模型，得到',
    winRate: '勝率最高',
    transaction: '的交易方案，並且自動執行。',
    transactionAdvantage: '相較於傳統的人工交易，量化交易的優勢在於，第一、交易不會受到人性的干擾，嚴格遵守交易紀律；第二、量化程序可高頻交易，每秒幾十次的交易是人工無法替代的；第三、AI量化程序不斷收集市場數據，可改變參數應對市場變化。',
    Advantage: {
      name: 'AI量化業務',
      AdvantageTitle1: '專業資深的國際背景',
      introduction1: '衍泰金融的核心團隊擁有頂尖的統計、IT、金融與風控背景，均擁有碩士以上學位。相較於投資收益，我們更加看重風險。確保每位參與者的資產穩定增值一直是我們的首要目標。',
      AdvantageTitle2: '充足的資金與嚴格的風控體系',
      introduction2: '衍泰金融擁有充足的資本金作為安全邊際，每位參與者可隨時查詢。在技術層面，我們的AI量化風控系統7*24小時不斷監測市場的風險指標，確保我們的交易永遠在安全的量化指標內進行。',
      AdvantageTitle3: '高度數據透明與知名合作機構',
      introduction3: '衍泰的合作方均為世界級的機構託管團隊與銀行，確保投資數字資產安全以及透明度。',
      structureTitle: '策略、數據、代碼展示',
      structureHome: '代碼示範、倉位展示（3個APP頁面截圖）、AI量化交易框架、投資回報率對比',
      structureF: '發現更多 →'
    },
    plan: {
      title: '量化服務',
      planName1: '共贏集合計劃',
      planName2: '穩贏專戶計劃',
      PlanHighlights: '計劃亮點:',
      PlanHighlights1_1: '通過集成託管賬戶，使每個小投資者都可以參與AI量化投資，分享收益。',
      PlanHighlights1_2: '衍泰承諾不會對小資金與大資金進行區分，公平分配收益。每位投資者無論資金大小均可以查詢後台數據。 ',
      PlanHighlights1_f: '發現更多',
      PlanHighlights2_1: '客戶可自行開設託管賬戶，即不需要劃轉資金到第三方託管賬戶。',
      PlanHighlights2_2: '衍泰僅有子賬戶的投資權限，並無資金劃轉權限。',
      PlanHighlights2_3: '大資金專戶在交易所手續費會有減免，可通過減少手續費的方式提升回報率。',
      PlanHighlights2_f: '注意:為保障現有投資者利益，本項目不定期開放募資，請聯繫投資顧問。'
    }
  },
  information: {
    name: '資訊中心',
    poster: '與趨勢同行，一起慢慢變有錢',
    today: '今天',
    moon: '月',
    day: '日',
    Sunday: '周日',
    Monday: '周一',
    Tuesday: '周二',
    Wednesday: '周三',
    Thursday: '周四',
    Friday: '周五',
    Saturday: '周六',
    homePage: '首頁',
    PreviousPage: '上一頁',
    NextPage: '下一頁',
    more: '了解更多'
  },
  contact: {

    HongKong: '香港',
    HongKong_1: '香港九龍大埔區通菜街111號雲之端大廈5樓509室(總部)',
    Wuhan: '武漢',
    Wuhan_1: '湖北省武漢市江岸區中山大道平安金融中心7樓715室(辦事處)',
    Changsha: '長沙',
    Changsha_1: '湖南省長沙市長沙縣紅樹灣18棟18樓(辦事處)',
    office: '聯繫我們',
    name: '聯繫我們',
    title: '客服全程協助，讓溝通更省心',
    office_one: '我們的地址',
    service: '我們致力於為全球客戶提供最優質的金融服務，為您的財富增值管理。歡迎垂詢我們的產品與服務詳情，歡迎您與我們聯繫。',
    formDesc: '客服全程協助，讓溝通更省心，請告訴我們您面臨的問題，以及我們該如何提供幫助，我們很樂意為您效勞。通常，我們會在幾分鐘內給予回復。',
    sendEmail: '發送郵件',
    companyAddress: '公司地址',
    yourEmail: '您的郵箱',
    yourName: '您的名字',
    yourQuestion: '您的問題',
    questionPlaceholder: '請在此輸入需要我們解答的問題...',
    emailPlaceholder: '請輸入郵箱',
    namePlaceholder: '請輸入您的名字',
    submit: '提交',
    submitSuccess: '感謝您的留言，我們會盡快回復！'
  },
  agreement:{
    Disclaimers: '免責聲明',
    rights: '2025 衍泰金融科技有限公司 保留一切權利',
    p1: '本報告由受香港特別行政區公司法監管的衍泰金融科技有限公司製作並於大中華地區分發。衍泰金融科技有限公司是由香港特別行政區註冊的責任有限公司。',
    p2: '本報告並非針對或意圖發送、發布給在當地法律或監管規則下不允許該報告發送、發布的人員。如有任何疑問，煩請向當地律師進行咨詢。',
    p3: '本報告在任何地區均不應被視為交易任何證券或金融工具的邀約或邀請。',
    p4: '本網站所包含的觀點及建議不適用於所有投資者，且並未考慮個別客戶的特殊情況、目標或需要，不應被視為對特定客戶關於特定證券或金融工具的建議或策略。',
    p5: '投資者不應以本網站取代其獨立判斷或僅依據本報告做出決策，並在需要時咨詢專家意見。本報告所載的意見、觀點及預測僅為本報告出具日分析師的觀點和判斷，相關證券或金融工具的價格、價值及收益亦可能會波動。',
    p6: '本報告中所引用的關於業績的數據代表過往表現，過往的業績表現並不能代表日後回報的預示。分析中所作的預測可能是基於相應的假設。任何假設的變化可能會顯著地影響所預測的回報，該等意見、觀點或預測無需通知即可隨時更改。',
    p7: '衍泰金融科技有限公司的銷售人員、交易人員及其他專業人士可能會依據不同假設和標準、採用不同的分析方法而口頭或書面發表與本報告意見及建議不一致的市場評論及/或交易觀點；衍泰金融科技有限公司的量化投資業務部門可能獨立作出與本報告的意見或建議不一致的投資決策；衍泰金融科技有限公司沒有將此意見及建議向報告所有接收者進行更新的義務。在不同時期，衍泰金融科技有限公司可能會發出與本報告所載意見、觀點與預測不一致的報告。',
    p8: '本報告的資料來自於我們認為可靠的來源，但衍泰金融科技有限公司：(1) 不保證任何資料的準確性、完整性、時間性或是否可以使用；(2) 不對使用本報告內之材料產生的任何直接或間接或相關之損失承擔任何責任。',
    p9: '衍泰金融科技有限公司：(1) 可能會持有本報告中所提到公司所發行的數字貨幣頭寸並進行交易；(2) 可能在特定數字資產交易所進行做市活動或莊家活動。',
    p10: '本報告僅供意向收件人使用，未經衍泰金融科技有限公司事先書面授權，任何機構或人士不得翻印、複製、分發或傳送本文件（無論整份和部分）給其他機構及/或人士。若經衍泰金融科技有限公司準許轉發，轉發人應獲取獨立的法律意見，以確定該轉發符合當地適用法規的要求。衍泰金融科技有限公司及其雇員不為轉發人及/或其客戶因使用本報告或報告載明的內容產生的直接或間接損失承擔任何責任。',
    name: '衍泰金融科技有限公司   香港特別行政區註冊責任有限公司'
  },
  privacy:{
    privacy: '隱私政策',
    name1: '1. 我們收集的信息',
    title1: '當您使用Matrix Power量化服務時，我們可能收集以下信息:',
    p1_1: '賬戶信息：您註冊時提供的姓名、聯繫方式、身份證明文件（用於合規驗證）',
    p1_2: '交易信息：您的投資策略選擇、資產配置、交易記錄等量化服務相關數據',
    p1_3: '設備信息：訪問設備的型號、IP地址、瀏覽器類型（用於安全風控）',
    name2: '2. 信息的使用方式',
    title2: '我們僅將收集的信息用於以下目的：',
    p2_1: '提供量化策略服務：基於您的投資偏好優化AI策略模型',
    p2_2: '合規與風控：遵守金融監管要求，防範交易風險',
    p2_3: '服務優化：分析用戶行為以提升產品體驗（匿名化處理後）',
    name3: '3. 信息的共享與披露',
    title3: '我們不會向第三方出售您的個人信息，僅在以下情況下共享：',
    p3_1: '獲得您的明確授權時',
    p3_2: '遵守法律法規、響應司法機關合法請求時',
    p3_3: '與提供必要技術支持的合作方共享（需簽署保密協議）',
    name4: '4. 信息的保護措施',
    title4: '我們採用符合金融行業標準的安全措施保護您的信息：',
    p4_1: '數據加密存儲與傳輸',
    p4_2: '訪問權限分級管控',
    p4_3: '定期安全審計與漏洞修復',
    name5: '5. 您的權利',
    title5: '您有權：',
    p5_1: '訪問、更正您的個人信息',
    p5_2: '在符合條件的情況下刪除您的賬戶信息',
    p5_3: '聯繫我們咨詢隱私相關問題（support@matrixpower.com）',
    name6: '6. 協議的變更',
    title6: '我們可能會根據業務或監管要求更新本政策，變更後將在官網顯著位置公告，若您繼續使用服務則視為接受變更。',
    retain: '2025 Matrix Power 保留所有權利'
  },
  appDownload: {
    download: 'APP下載',
    butler: '您的一鍵式資本增長平臺',
    title: '以頂尖的AI量化策略為投資者賦能，零風險享受每日穩健收益！',
    trust: '深受全球用戶信賴',
    relyOn: '服務資產均在瑞銀投保，杜絕非市場性風險，安享收益',
    establish: '成立於',
    user: '服務的用戶',
    country: '服務範圍',
    globalUsers:'全球用戶',
    restriction:'(限制地區除外)',
    confirm: '請確認',
    prompt: '即將下載 MatrixPower App 安裝包（apk格式），請確保裝置允許未知來源應用程式安裝',
    Cancel: '取消',
    download: 'APP下載',
    list: {
      header_1: '模組分區，讓使用更簡單',
      p1_1: '隨時隨地，讓您更方便的投資',
      p1_2: '以數據驅動決策，多方面展示各數位幣漲跌情況',
      header_2: '技術驅動，量化策略套裝矩陣',
      p2_1: '明確標注每個套餐的收益範圍，每日獲取收益，隨存隨取，共亯收益！',
      p2_2: '多種投資套餐可選，投資更靈活。',
      header_3: '智能採集資訊，打破壁壘',
      p3_1: '通過NLP科技對全球數位資產市場的關鍵資訊進行抓取，讓客戶實时掌握最新市場動向。',
      p3_2: '支持用戶互動，構建積極的投資生態。',
      footList1: {
        Header1: '首頁',
        title1: '活動預告',
        Header2: '功能',
        title2: '穩健收益',
        Header3: '資訊',
        title3: '最新熱點',
      },
      footList2: {
        Header1: '基礎',
        title1: 'AI量化策略',
        Header2: '亮點',
        title2: '穩定收益',
        Header3: '安全',
        title3: '保本保息',
      },
      footList3: {
        Header1: '跨平台',
        title1: '即時抓取',
        Header2: '量化',
        title2: '多次推送',
        Header3: '互動',
        title3: '按讚評論',
      },
    }
  },

  footer: {
    address: "湖北省武漢市江岸區中山大道平安金融中心7樓715室",
    nav: {
      contact: "聯繫我們",
      compliance: "合規資質",
      navigation: "導航",
      legal: "法律條款",
      academy: "行泰學院",
      about: "行泰量化",
      home: "首頁",
      privacy: "隱私政策",
      terms: "服務條款",
      risk: "風險披露",
      followUs: "關注我們"
    },
    copyright: "©2026 MatrixPower",
    disclaimer: {
      p2: "服務受地域限制，部分國家/地區用戶可能無法使用全部功能。",
      p1: "虛擬貨幣投資存在風險，過往收益不代表未來盈利。MatrixPower不對任何投資損失承擔責任。"
    }
  },
  quantPage: {
    essence: {
      title1: '量化交易的',
      titleHl: '本質',
      desc: '利用數學模型、統計分析和計算機程序，從海量數據中尋找規律並自動執行交易指令的投資方式。它通過數據驅動決策，旨在排除人為情緒干擾，實現理性投資',
      trend: '預測走勢',
      factor: '因子分析',
      auto: '自動交易'
    },
    strategy: {
      tag: '核心策略',
      title: '量化投資策略',
      subtitle: '通過AI模型算例優勢，充分挖掘顯性因子，不斷提升交易勝率。',
      card1Title: '三大策略獨立運作',
      card1Desc: '數字資產、外匯、期權三大策略線獨立運營，獨立風控，穩中求勝。',
      card2Title: '專業團隊精細化管理',
      card2Desc: '每條策略線配備專屬投研、風控團隊，實時監控、動態調優',
      card3Title: '月度統計均正收益',
      card3Desc: '所有策略在月度統計中均取得正收益，業績表現穩定'
    },
    matrix: {
      title: '產品矩陣',
      tab1: '外匯多因子交易',
      tab2: '跨所無風險套利',
      tab3: 'A股ETF期權拐點超高Alphal'
    },
    chart: {
      title: '平均收益率',
      subtitle: '基於近10年交易數據測試',
      annual: '年化收益率',
      monthly: '月化收益率',
      annualVal1: '71%',
      annualVal2: '24%',
      annualVal3: '104%',
      monthlyVal1: '5.19%',
      monthlyVal2: '2%',
      monthlyVal3: '8.67%',
      minInvest: '最低起投門檻',
      minInvestVal1: '$2.5萬',
      minInvestVal2: '$2000萬',
      minInvestVal3: '$100萬',
      lossProb: '虧損概率',
      lossProbSub: '最大虧損率為10%'
    },
    p1: {
      title: '外匯多因子交易模型',
      subtitle: '多因子 AI 建模分析，智能執行高頻外匯交易',
      f1: '採集近 10 年全球主流外匯市場完整交易數據',
      f2: 'AI 大模型抓取 30 + 漲跌顯性因子，組合建模策略',
      f3: '自動化高頻交易，依託顯性因子自行開倉、平倉',
      f4: '強止損線為10%，嚴格風控'
    },
    p2: {
      title: '跨所無風險套利模型',
      subtitle: '捕捉同標的跨交易所價差，對沖實現穩定套利',
      f1: '衍泰兜底保障，虧損超1%由衍泰承擔賠付',
      f2: '收益率參考歷史數據預估',
      f3: '對沖套利模式，鎖定價差收益'
    },
    p3: {
      title: 'A股ETF期權拐點超高Alphal',
      subtitle: '依託期權定價偏差/跨市場價差，構建對沖組合獲取收益',
      f1: '預測指數日K拐點，判斷月度方向',
      f2: '通過期權定價模型尋找錯誤定價',
      f3: '收穫超高Alpha收益'
    },
    coop: {
      tag: '合作模式',
      title: '為什麼選擇衍泰量化?',
      c1Title: '資金安全保障',
      c1i1t: '資金物理隔離',
      c1i1d: '客戶自行開戶，衍泰僅獲取API交易權，限絕無資金劃轉權限，確保本金絕對安全。',
      c1i2t: '雙重風控攔截',
      c1i2d: '自研專業風控模型實時監控異常波動，將市場系統性風險和策略模型回撤風險降至行業最低水平。',
      c1i3t: '極致流動性保障',
      c1i3d: '全線產品均不設置封閉期，投資者可根據自身資金需求隨時發起提款，確保資產的高流動性。',
      more1: '點擊查看更多',
      c2Title: '全天候陪伴式輔導',
      c2i1t: '平台開戶',
      c2i1d: '提供完善的平台開戶指導，快速完成註冊流程。',
      c2i2t: 'API綁定',
      c2i2d: '協助完成API接口綁定，確保交易順暢運行。',
      c2i3t: '出入金操作',
      c2i3d: '資金進出自由，操作簡單快捷，隨時掌控賬戶資金。',
      more2: '點擊查看更多',
      c3Title: '陽光分潤機制',
      c3i1t: '透明分潤流程',
      c3i1d: '每月1-3日統計上月盈利併發送對應賬單給客戶，客戶核對賬單後需要主動支付50%技術服務費。衍泰沒有客戶資產的劃轉權限，嚴格保護客戶資產'
    },
    philo: {
      tag: '投資理念',
      title: '長期共贏 · 行穩致遠',
      subtitle: '信任是金融世界的基石，透明是對投資者的承諾',
      card1Title: '資金容量管控',
      card1Desc: 'AI量化策略對資金容量高度敏感，衍泰通過不定期邀請制嚴格控制規模，保護現有客戶收益',
      card2Title: '機構定位堅守',
      card2Desc: '堅守專業量化投資機構定位，只為客戶取得合理的資本增值，堅守風控與合規底線',
      card3Title: '長期共贏生態',
      card3Desc: '與理念契合的合作夥伴建立跨越週期的長期共贏生態，追求長期穩定資本增值'
    },
    trust: {
      titlePre: '信任',
      titlePost: '是衍泰最寶貴的資產',
      title2: '行穩方能致遠',
      btn: '立即加入'
    }
  },
  yantai: {
    heroHl: '衍泰AI',
    heroTitle: '給予未來無限可能',
    heroDesc: '衍泰作為最早一批深度訓AI模型的公司，已擁有成熟的AI應用，包括量化交易輔助、AI推廣引擎、AIgennext項目孵化器',
    heroBtn1: 'AI推廣引擎',
    heroBtn2: 'AiGenNext',
    headerTitle: 'AI推廣引擎',
    headerDesc: '通過AI模型，擬人化操作300-500個真實設備，自主搜索、發布、添加、回復，做到7*24流量推廣',
    box1Title: '多設備統一管控',
    box1Desc: '多設備統一管控，高效統籌內容發布',
    box1Item1: '單後台批量管理海量設備，免去多端反覆登錄',
    box1Item2: '省去複製粘貼改格式繁瑣步驟，深耕創意與策略',
    box1Item3: '兼容圖文視頻鏈接表情多類素材，適配各大平台',
    box1Item4: '貼合平台算法與用戶偏好，差異化內容一鍵分發',
    panel1Name: '多設備統一管控',
    panel1Subtitle: '開啟後批量管理海量設備，提高效率',
    panel1Add: '添加設備',
    panel1StatTotal: '設備總數',
    panel1StatOnline: '在線設備',
    panel1StatOffline: '離線設備',
    panel1StatStandby: '待機設備',
    panel1Search: '請輸入設備名稱/ID',
    panel1TagAll: '全部',
    panel1TagOnline: '在線',
    panel1TagOffline: '離線',
    panel1TagIdle: '空閒',
    panel1Batch: '批量操作',
    panel1BadgeMaster: '主控',
    panel1BadgeActive: '活躍',
    panel1BadgeStandby: '待機',
    panel1BadgeOffline: '離線',
    panel1DevId: 'ID: D-1024 最後活躍: 12:38',
    panel1StOnline: '在線',
    panel1StIdle: '空閒',
    panel1StOffline: '離線',
    box2Title: 'AI智能互動',
    box2Desc: '行業知識自動採集，AI賦能智能社交運營',
    box2Item1: '關鍵詞識別、完成情緒分析、自動回復',
    box2Item2: '結合情感圖分析，實現精準用戶互動',
    box2Item3: '自動捕捉潛在用戶',
    box2Item4: '助力品牌社交媒體運營更專業高效',
    panel2Name: 'AI智能互動',
    panel2Subtitle: '自動回復、自動捕捉潛在用戶',
    auto: '自動',
    p2c1Name: 'AI評論自動回復',
    p2c1Desc: '感謝您的支持！更多詳情請關注主頁 👇',
    p2c2Name: 'AI私信自動回復',
    p2c2Desc: '“您好，請問有什麼可以幫到您的？”',
    p2c3Name: 'AI自動改寫',
    p2c3Desc: '已針對 TikTok/Ins 生成差異化版本文案',
    p2c4Name: 'AI監控回復',
    p2c4Desc: '已自動回復 5 條正面提及',
    p2c5Name: '關鍵詞識別',
    p2c5Desc: '實時抓取行業熱點，完成情緒分析',
    p2c6Name: '潛在用戶捕捉',
    p2c6Desc: '自動識別意向用戶，提升客戶轉化效率',
    p2c7Name: '智能運營助手',
    p2c7Desc: '助力品牌社交媒體運營更專業高效',
    p2s1: '今日互動總量',
    p2s1Unit: '次',
    p2s1Trend: '較昨日 +12%',
    p2s2: '節省運營成本',
    p2s2Unit: '小時',
    p2s2Trend: '自動處理87%常規諮詢',
    p2s3: '自動回復數量',
    p2s3Unit: '條',
    p2s3Trend: '私信12·評論35',
    p2s4: '潛在用戶捕捉',
    p2s4Unit: '人',
    p2s4Trend: '今日新增意向用戶',
    box3Title: 'AI一鍵產出素材',
    box3Desc: '一句話下達需求，AI一站式生成處理內容',
    box3Item1: '一句話輸入需求，AI自動生成圖片、視頻',
    box3Item2: '自動適配各平台尺寸，支持一鍵多語言翻譯',
    box3Item3: '素材文案自動歸檔入庫，直達發布編輯器',
    box3Item4: '支持定時發送，降低團隊運營成本',
    panel3Name: 'AI 素材創作',
    panel3Subtitle: '視頻、圖片、文章',
    styleTitle: '風格模型',
    more: '更多',
    styleRealistic: '寫實',
    styleIllustration: '插畫',
    style3D: '3D',
    styleCinematic: '電影感',
    styleWatercolor: '水彩',
    styleCyber: '賽博',
    p3Ph1: '上傳參考圖、輸入文字，',
    p3Ph2: '描述你想生成的圖片',
    p3Generate: '生成',
    p3Save: '保存設計',
    box4Title: '7×24小時在線',
    box4Desc: '7×24 小時全天候值守，安全守護品牌運營',
    box4Item1: '7×24小時在線，智能高效執行各類任務',
    box4Item2: '提供企業級安全防護保障',
    box4Item3: '全自動全天候處理，重要信息零遺漏',
    box4Item4: '即時響應用戶，持續守護品牌形象',
    agHead1: 'Web3',
    agHead2: '到AI',
    agHead3: '的進化',
    agDesc: 'Aigennext是基於衍泰AI的一個孵化項目，核心理念是：“AI創造價值，人類共享收益”',
    agBtn: '開始探索'
  },
  aboutPage: {
    heroPre: '量化交易+',
    heroHl: 'AI智能',
    heroSub: '複合型公司',
    heroTagline: '" 汇聚财智 · 行稳致远 · 共享未来 "',
    coDesc: '以香港為總部，武漢、長沙為分佈的跨區域的金融科技機構，覈心團隊均來自國際頂尖大廠與投資銀行',
    statFounded: '成立年份',
    statScale: '美元 服務規模',
    statAlgo: '算法自主',
    tag1: '持牌合規',
    tag2: '自研算法',
    tag3: '全球視野',
    advTitle: '衍泰的優勢',
    advSubtitle: '衍泰擁有前沿的AI智能體開發技術，團隊專業背景深厚、量化研究經驗豐富，讓您的選擇更有保障',
    tab1: 'AI智能體',
    tab2: '精幹核心團隊',
    tab3: '嚴格的風險控制',
    a1l1h: '自主研發',
    a1l1r: 'AI大模型',
    a1l2r: '高頻交易獲取',
    a1l2h: '超額收益',
    a1l3r: '精準抓取超',
    a1l3m: '個',
    a1l3b: '顯性因子',
    a2l1h: '15+',
    a2l1r: '精英團隊',
    a2l2h: '90%',
    a2l2r: '以上碩士/博士',
    a2l3r: '量化研究',
    a2l3h: '經驗豐富',
    a2l4: '技術底蘊深厚',
    a3l1h: '實時',
    a3l1r: '價值監控',
    a3l2h: '多維度',
    a3l2r: '壓力測試',
    a3l3h: '嚴格',
    a3l3r: '的止損與倉位',
    a3l4: '管理機制',
    visionTitle: '公司願景',
    visionDesc1: '以智能重新定義量化、以量化賦能智能，成為',
    visionDesc2: '全球領先的AI驅動型資產管理機構'
  },
  appd: {
    servedUsers: '服務12000+',
    usersLabel: '全球(限制地區除外)用戶',
    trustDesc: 'MatrixPower APP深受全球用戶信賴，提供資產託管和智能配置，杜絕非市場性風險，安享收益',
    statRegion: '交易地區',
    statDownloads: '下載量',
    statRating: '用戶評分',
    statPositive: '好評率',
    f1t: '模組分區',
    f1d: '理財計劃、社區資訊實時同步，數據智能分析，全天候監控交易狀態，提供最優投資策略',
    f2t: '技術驅動',
    f2d: '前沿的AI量化策略算法，超99%的識別率，自動執行，風控體系完善，投資更安全',
    f3t: '交易透明',
    f3d: '實時資金監控，確保資金流轉安全透明，區塊鏈加密存儲，確保用戶資產安全',
    f4t: '技術支持',
    f4d: '提供7x24小時專業服務，快速響應機制保障交易順暢，確保用戶問題及時處理',
    secSubtitle: '機構級安全保障，合規監管透明可查，通過KFC和AML實現多層防護，並獲得SOC2 TypeII認證',
    assetTitle: '客戶資產保障',
    assetL1: '資產分倉存儲',
    assetL2: 'APP內資產冷存儲',
    assetL3: '數字資產安全隔離',
    tagPrincipal: '本金絕對安全',
    tagSelfOpen: '自行開戶',
    dualL1: '活體專業風控團隊實時監控智能預警',
    dualL2: 'SOC 2 Type II認證',
    tagRiskModel: '自研風控模型',
    transTitle: '交易透明機制',
    transL1: '全鏈路交易數據可查',
    transL2: '智能防篡改加密',
    transL3: '實時對賬，按秒刷新，一天可多次查看',
    tagRealtime: '實時可查',
    tagLiquid: '高流動性',
    ctaDesc: '服務資產均在鏈上投保，杜絕非市場性風險，安享收益'
  },
}